// import _ from 'lodash'
import { createFormulaDoc, createMasterDoc } from './designDocs.js'

console.log('PROCESS', process.env)
const user = process.env.VUE_APP_COUCH_USER;
const pwd = process.env.VUE_APP_COUCH_PASS;
const protocol = process.env.VUE_APP_COUCH_PROTOCOL;
const COUCH_ADDR = process.env.VUE_APP_COUCH_ADDR || `${window.location.host}/couch`
export const db_names = ['masters', 'operations', 'reports', 'registry']
export const support_db = 'support'
export const remote_db_url = `${protocol}://${user}:${pwd}@${COUCH_ADDR}`
export const db_views_sync = {
    'masters': ['masters/masters'],
    'operations': ["operations/searchByData"],
    "reports": ["reports/searchByData"],
    'registry': [
        "registry/searchByData", //"registry/searchByContact",
        "primary/searchByData", 
        "instruments/searchByData"
    ]
}
export const db_views_async = {
    'masters': [],
    'operations': [],
    "reports": [],
    'registry': [
        "registry/searchByContact",
        "primary/searchByText",
        "instruments/searchByText",
        "clients/searchByText"
    ]
}


const objStrToLower = (item, values, order) => {
    let orderFields = []
    for (let i = 0; i < values.length; i++) {
        let val = _.get(item, values[i])
        if ((typeof val) == 'string') {
            orderFields.push(val.toLowerCase())
        } else if (isNaN(val)) {
            orderFields.push((order[i] == 'asc') ? Infinity : -Infinity)
        } else {
            orderFields.push(val)
        }
    }
    return orderFields
}


export const orderByFields = (items, fields) => {
    return _.orderBy(items, [item => objStrToLower(item, fields.value, fields.order)], fields.order)
}


export const searchDesign = async(db_ref, db, view, sel_type, selectors, reduce, limit = null, order = 'descending') => {
    // console.log('search****', sel_type, selectors)
    let results = null
    let first = true
    let res = null
    let words = []
    switch (sel_type) {
        case 'text':
            words = selectors.toLowerCase().split(' ')
                // console.log('TEXT SELECTORS', selectors, words)
            for (let word of words) {
                let res = await db_ref.query(db, view, {
                    startkey: word,
                    endkey: word + '\uffff',
                    reduce: false
                        //include_docs:true
                });
                // console.log('res', word, res)
                // count strlen 

                let f_res = _.uniqBy(res.rows, 'id')
                if (first) {
                    results = f_res;
                    first = false;
                } else {
                    results = _.intersectionBy(results, f_res, 'id')
                }
            }
            break
        case 'range':
            res = await db_ref.query(db, view, {
                startkey: selectors[0],
                endkey: selectors[1],
                reduce: false
            })
            results = _.uniqBy(res.rows, 'id')
            break
        case 'key':
            res = await db_ref.query(db, view, {
                key: selectors,
                reduce: reduce
            });
            results = _.uniqBy(res.rows, 'id')
            break
        case 'keys':
            res = await db_ref.query(db, view, {
                keys: selectors,
                reduce: reduce
            });
            // AND KEYS
            results = _.uniqBy(res.rows, 'id')
            break;
        case 'all_keys':
            results = []
            res = await db_ref.query(db, view, {
                keys: selectors,
                reduce: reduce
            });
            // AND KEYS
            res = _.groupBy(res.rows, 'id')

            for (let id in res) {
                if (res[id].length == selectors.length) {
                    results.push(res[id][0])
                }
            }
            break;
    }
    if (limit) {
        results = results.slice(0, limit)
    }
    return results
}

export const searchByText = async(db_ref, db, view, s_word) => {
    // console.log('search****')
    if (s_word == undefined || s_word == null) {
        s_word = ''
    }
    if (s_word.trim() != '' && s_word.length < 2) {
        // search disabled for short search
        console.log('SKIP')
        return null;
    }

    let words = s_word.toLowerCase().split(' ')

    let items = [];
    let first = true;
    let counter = {
        char: 0,
        word: 0
    }
    for (let word of words) {
        let res = await db_ref.query(db, view, {
            startkey: word,
            endkey: word + '\uffff',
            reduce: false
                //include_docs:true
        });
        //console.log('res', word, res)
        // count strlen 
        for (let row of res.rows) {
            counter.char += row.key.length
            counter.word += 1
        }
        let f_res = _.uniqBy(res.rows, 'id')
        if (first) {
            items = f_res;
            first = false;
        } else {
            items = _.intersectionBy(items, f_res, 'id')
        }
    }
    // console.log('filtered items', items)
    // console.log('view counter', counter)
    return items
}

export const searchForExt = async(db_ref, db, view, s_word) => {
    console.log('search****')
    if (s_word == undefined || s_word == null) {
        s_word = ''
    }
    if (s_word.trim() != '' && s_word.length <= 3) {
        // search disabled for short search
        console.log('SKIP')
        return null;
    }

    let word = s_word.toLowerCase()

    let items = [];
    let first = true;
    let counter = {
        char: 0,
        word: 0
    }
    let res = await db_ref.query(db, view, {
        startkey: word,
        endkey: word,
        reduce: false
            //include_docs:true
    });
    // console.log('res', word, res)
    // count strlen 
    for (let row of res.rows) {
        counter.char += row.key.length
        counter.word += 1
    }
    let f_res = _.uniqBy(res.rows, 'id')
    if (first) {
        items = f_res;
        first = false;
    } else {
        items = _.intersectionBy(items, f_res, 'id')
    }
    // console.log('filtered items', items)
    // console.log('view counter', counter)
    return items
}

export const createMastercalDesignDocs = async(db_ref) => {
    // console.log('createMastercalDesignDocs', db_ref)
    let master_design = await db_ref.allDocs('masters', {
        startkey: "_design",
        endkey: "_design\ufff0",
        include_docs: true
    })
    let designMaster = false;
    let designFormula = false

    // console.log("query design docs MASTER", master_design)
    for (let designDoc of master_design.rows) {
        switch (designDoc.id) {
            case '_design/masters':
                designMaster = true
                break;
            case '_design/formulas':
                designFormula = true
                break;
        }
    }
    if (!designMaster) {
        db_ref.put('masters', createMasterDoc()).then(
            res => { console.log(res) })
    }
    if (!designFormula) {
        db_ref.put('masters', createFormulaDoc()).then(
            res => { console.log(res) })
    }

}

function empty_function() {}

export const connectRemoteDb = async (db_ref, db) => {
  var res = await db_ref.connect(user, pwd, db);
  console.log('connected to ', db, 'result:',res)
  return res;
}

export const dbPull = (db_ref, db, options = {}, complete_func = empty_function, change_func = empty_function, error_func = empty_function, active_func = empty_function, paused_func = empty_function) => {
    let _options = {... { live: false, retry: false }, ...options }
    let pull_res = db_ref.pull(db, `${remote_db_url}/${db}`, _options)
        .on('complete', complete_func)
        .on('change', change_func)
        .on('paused', paused_func)
        .on('active', active_func)
        .on('error', error_func)
    return pull_res
}


export const syncDbPull = async(db_ref, db, options = {}) => {
    let _options = {... { live: false, retry: false }, ...options }
        //console.log("db", db, "- sync pull starting...")
    let pull_res = await db_ref.pull(db, `${remote_db_url}/${db}`, _options)
    return pull_res
}


export const dbPush = (db_ref, db, options = {}, complete_func = empty_function, change_func = empty_function, error_func = empty_function) => {
    let _options = {... { live: false, retry: false }, ...options }
        // console.log("db", db, "- push starting... user: ", user)
    let push_res = db_ref.push(db, `${remote_db_url}/${db}`, _options)
        .on('complete', complete_func)
        .on('change', change_func)
        .on('error', error_func)
    return push_res
}


export const startSyncDb = (pouch, store, db, change_pull_func=empty_function) => {
    let db_pull = null
    let db_push = null
    console.log("StartSyncDb - SET SELECTOR", store.state.user.org_id)
    let db_selector = store.state.db_doc_selectors[db]
    if (!store.state.user.roles.includes('admin') && !store.state.user.roles.includes('reviewer') && !store.state.user.roles.includes('supervisor')) {
        db_selector['org'] = store.state.user.org_id
        db_selector['user'] = store.state.user._id
    }
                    
    var query = getQuery(db, db_selector, false)
    let options = {
            live: true,
            retry: true,
            // filter: db + '/current_version',
            // query_params: db_selector,
            since: store.state.sync_since[db],
            selector: query,
            style: "main_only",
            back_off_function: function(delay) {
                console.log('BACKOFF DELAY pull', db, delay)
                if (delay === 0) {
                    return 1000;
                }
                if (delay >= 216000) {
                    return delay
                }
                return delay * 3;
            }
        }
    db_pull = dbPull(pouch, db, options, empty_function, change_pull_func)
    db_push = dbPush(pouch, db, {
        live: true,
        retry: true,
        style: "main_only",
        back_off_function: function(delay) {
            console.log('BACKOFF DELAY push', db, delay)
            if (delay === 0) {
                return 1000;
            }
            if (delay >= 216000) {
                return delay
            }
            return delay * 3;
        }
    })

    return db_pull, db_push
}

export const updateViews = async(pouch, wait) => {
    if (wait) {
        console.log("%%%%%%% SYNC start generatin views", Date.now())
        for (let db of db_names) {
            console.log("DB -", db, db_views_sync[db])
            for (let view of db_views_sync[db]) {
                console.log("%%%%%%%%% GENERATION", db, view)
                await pouch.query(db, view)
            }
            
            console.log("DB -", db, db_views_async[db])
            for (let view of db_views_async[db]) {
                console.log("%%%%%%%%% GENERATION", db, view)
                pouch.query(db, view)
            }
        }
        console.log("%%%%%%% ASYNC finish generation views", Date.now())
    } else {
        console.log("%%%%%%% ASYNC start generatin views", Date.now())
        for (let db of db_names) {
            console.log("DB -", db, db_views_sync[db])
            for (let view of db_views_sync[db]) {
                console.log("%%%%%%%%% GENERATION", db, view)
                pouch.query(db, view)
            }
            
            console.log("DB -", db, db_views_async[db])
            for (let view of db_views_async[db]) {
                console.log("%%%%%%%%% GENERATION", db, view)
                pouch.query(db, view)
            }
        }
    }
}

const not_deleted_query = {
    "$or": [
        {
           "_deleted": {
              "$exists": false
           }
        },
        {
           "_deleted": {
              "$ne": true
           }
        }
    ]
}

export const getRegistrySelector = (selectors, first_copy) => {
    const query = {'$or': [
        {'_id': '_design/registry'},
        {'_id': '_design/primary'},
        {'_id': '_design/instruments'},
        {'_id': '_design/clients'},
        {'_id': '_design/organisms'},
        {
            doc_type: 'instrument',
            primary: true,
            ...(selectors['org'] && {used_by: selectors['org']}),
            version: selectors['instruments'],
            ...(first_copy && not_deleted_query)
        },
        {
            doc_type: 'instrument',
            primary: false,
            ...(selectors['org'] && {ref_orgs: {'$in': [selectors['org']]}}),
            ...(selectors['locations'] && {location_id: {'$in': selectors['locations']}}),
            version: selectors['instruments'],
            ...(first_copy && not_deleted_query)
        },
        {
            doc_type: 'client',
            ...(selectors['org'] && {ref_orgs: {'$in': [selectors['org']]}}),
            ...(selectors['clients'] && {_id: {'$in': selectors['clients']}}),
            version: selectors['client'],
            ...(first_copy && not_deleted_query)
        },
        {
            doc_type: 'location',
            ...(selectors['org'] && {ref_orgs: {'$in': [selectors['org']]}}),
            ...(selectors['clients'] && {client_id: {'$in': selectors['clients']}}),
            version: selectors['location'],
            ...(first_copy && not_deleted_query)
        },
        {
            doc_type: 'organism',
            version: selectors['organism'],
            ...(first_copy && not_deleted_query)
        },
        {
            doc_type: "primary_loan",
            version: selectors["primary_loan"],
            ...(first_copy && not_deleted_query)
        },
        {
            doc_type: "procedure",
            version: selectors["procedure"],
            ...(first_copy && not_deleted_query)
        }
    ]}

    return query
}

export const getMastersSelector = (selectors, first_copy) => {
    const query = {'$or': [
        {'_id': '_design/masters'},
        {'_id': '_design/formulas'},
        {
            doc_type: 'imagepoint',
            version: selectors['imagepoint'],
            ...(first_copy && not_deleted_query)
        },
        {
            doc_type: 'baseblock',
            version: selectors['baseblock'],
            ...(first_copy && not_deleted_query)
        },
        {
            doc_type: 'master',
            version: selectors['master'],
            ...(first_copy && not_deleted_query)
        },
        {
            doc_type: 'formula',
            version: selectors['formula'],
            ...(first_copy && not_deleted_query)
        },
        {
            doc_type: 'category',
            version: selectors['category'],
            ...(first_copy && not_deleted_query)
        },
        {
            doc_type: 'config',
            version: selectors['config'],
            ...(first_copy && not_deleted_query)
        },
        {
            doc_type: 'manufacturer',
            version: selectors['manufacturer'],
            ...(first_copy && not_deleted_query)
        }
    ]}

    return query
}

export const getOperationsSelector = (selectors, first_copy) => {
    const query = {'$or': [
        {'_id':  '_design/operations'},
        {
            ...(selectors['org'] && {org_id: selectors['org']}),
            ...(selectors['user'] && {assigned: {'$in': [selectors['user']]}}),
            version: selectors['operation'],
            sync: true,
            ...(first_copy && {dismissed: false}),
            ...(first_copy && not_deleted_query),
            //...(first_copy && {sync: true})
        }
    ]}
    return query
}

export const getReportsSelector = (selectors, first_copy) => {
    // const query = {'$or': [
    //     {'_id':  '_design/reports'},
    //     {
    //         ...(selectors['org'] && {org_id: selectors['org']}),
    //         ...(selectors['operations'] && {operation_id: {'$in': selectors['operations']}}),
    //         ...(selectors['user'] && {owner_id: selectors['user']}),
    //         version: selectors['report'],
    //         ...(first_copy && not_deleted_query)
    //     }
    // ]}
    const query = {'$or': [
        {'_id':  '_design/reports'},
        {
            ...(selectors['org'] && {org_id: selectors['org']}),
            version: selectors['report'],
            ...(first_copy && not_deleted_query),
            '$or' : [
                {
                    ...(selectors['instruments_ids'] && {instrument_id: {'$in': selectors['instruments_ids']}}),
                },
                {
                    ...(selectors['operations'] && {operation_id: {'$in': selectors['operations']}}),
                    ...(selectors['user'] && {owner_id: selectors['user']})
                }
            ]

        }
    ]}
    return query
}


// OPERATIONS - locations, clients, operations
// 	assigned = context.state.user._id
// 	op_sync = true
	
// REGISTRY
// 	org_id = user.org_id
// 	OR	
// 		doc_type=instrument
// 		OR
// 			primary = true
// 		OR
// 			location_id in [locations]
// 	or
// 		doc_type=client
// 		client_id in clients
// 	OR
// 		doc_type = location
// 		client_id in clients
// REPORTS
// 	op_id in operations
// 	owner_id = user._id
	
	
// OPERATIONS - locations, clients, 
// 	assigned = context.state.user._id	
// REGISTRY
// 	OR	
// 		doc_type=instrument
// 		OR
// 			primary = true
// 		OR
// 			location_id in [locations]
// 	or
// 		doc_type=client
// 		client_id in clients
// 	OR
// 		doc_type = location
// 		client_id in clients
// REPORTS
// 	op_id in operations
	

export const getQuery = (db_name, selectors, first_copy) => {
    var query = {}
    switch(db_name) {
        case 'registry':
            query = getRegistrySelector(selectors, first_copy)
            break;
        case 'operations':
            query = getOperationsSelector(selectors, first_copy)
            break;
        case 'reports':
            query = getReportsSelector(selectors, first_copy)
            break;
        case 'masters':
            query = getMastersSelector(selectors, first_copy)
            break;
    }
    return query
}